document.addEventListener('DOMContentLoaded', () => {
  const getWishlist = () => JSON.parse(localStorage.getItem('mm_wishlist') || '[]');
  const saveWishlist = (list) => localStorage.setItem('mm_wishlist', JSON.stringify(list));

  document.querySelectorAll('.wishlist-btn').forEach(btn => {
    const id = btn.dataset.productId;
    if (getWishlist().find(p => p.id === id)) {
      btn.classList.add('active');
      btn.textContent = '♥';
    }

    btn.addEventListener('click', (e) => {
      e.preventDefault();
      let list = getWishlist();
      const exists = list.find(p => p.id === id);
      if (exists) {
        list = list.filter(p => p.id !== id);
        btn.classList.remove('active');
        btn.textContent = '♡';
      } else {
        list.push({
          id,
          title: btn.dataset.productTitle,
          url: btn.dataset.productUrl,
          image: btn.dataset.productImage
        });
        btn.classList.add('active');
        btn.textContent = '♥';
      }
      saveWishlist(list);
    });
  });
});